import { DeficiencyModel } from "./deficiency.model"

export class DAPDeficiency {
    public pageName: string
    public deficiencyCount: number
    public deficiencyNotes: DeficiencyModel[]
    public expanded = false
  
    constructor(page, count){
      this.pageName = page
      this.deficiencyCount = count
    }
  }